interface CheckboxProps {
    name: string;
    label: string;
    checked: boolean | undefined;
    onChange: (checked: boolean, which: string) => Promise<void>;
    disabled?: boolean;
}

export default function CheckboxGeneric({
    name,
    label,
    checked,
    onChange,
    disabled = false
}: CheckboxProps) {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        void onChange(event.target.checked, name);
    };

    return (
        <div>
            <label className="label cursor-pointer gap-2">
                <input
                    name={name}
                    type="checkbox"
                    className="checkbox"
                    checked={checked}
                    onChange={handleChange}
                    disabled={disabled}
                />
                {label}
            </label>
        </div>
    );
}
